import React, { useState, useEffect } from 'react';
import Chart from 'chart.js/auto';
import { Bar, Doughnut } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import apiService from '../../../services/apiService';
import { useParams } from 'react-router-dom';
import Loader from '../../layouts/loader';

const Stats = () => {
  const [uCourseScore, setUCourseScore] = useState()
  const [userCoursepAttempts, setUserCoursepAttempt] = useState()
  const [orgUserTestCardData, setOrgUserTestCardData] = useState()
  const [coursePerformances, setCoursePerformances] = useState()
  const [activeFilter, setActiveFilter] = useState('all');
  const { course_id, course_name, org_course_id } = useParams();
  const [coursePerformanceData, setCoursePerformanceData] = useState()
  const [coursePerformanceAnalyticsDatas, setCoursePerformanceAnalyticsDatas] = useState()
  const [coursePerformancesAnalytics, setCoursePerformancesAnalytics] = useState()
  const [courseAttempData, setCourseAttempData] = useState()
  const [courseScoreData, setCourseScoreData] = useState()
  const [loader, setLoader] = useState(false);
  const barWidth = 20;
  const orgId = localStorage.getItem("ORGID");

  const dataByFilter = {
    all: {
      labels: ['All'],
      datasets: [
        {
          label: 'All',
          data: [7.2],
          backgroundColor: '#D9E8EE',
          barThickness: barWidth,
        },
        {
          label: 'All',
          data: [9.6],
          backgroundColor: '#146B90',
          barThickness: barWidth,
        },
      ],
    },
    entity: {
      labels: ['Finance', 'Technology', 'Admin'],
      datasets: [
        {
          label: 'Entity Data',
          data: [25, 15, 30],
          backgroundColor: '#D9E8EE',
          barThickness: barWidth,
        },
      ],
    },
    department: {
      labels: ['Finance', 'Technology', 'Admin'],
      datasets: [
        {
          label: 'Department Data',
          data: [25, 15, 30],
          backgroundColor: '#D9E8EE',
          barThickness: barWidth,
          categoryPercentage: 1.1, // Adjust this value for spacing
          barPercentage: 1.1, // Adjust this value for spacing
        },
      ],
    },
    age: {
      labels: ['18-30 yrs', '31-45 yrs', '46-65 yrs', '66-80 yrs', '80+yrs'],
      datasets: [
        {
          label: 'Age',
          data: [6.7, 7.7, 6.4, 8.2, 8.0],
          backgroundColor: '#D9E8EE',
          barThickness: barWidth,
        },
        {
          label: 'Age',
          data: [9.6, 9.6, 9.6, 9.6, 9.6],
          backgroundColor: '#146B90',
          barThickness: barWidth,
        },
      ],
    },
    gender: {
      labels: ['Male', 'Female', 'Others'],
      datasets: [
        {
          label: 'Gender',
          data: [12, 18, 5],
          backgroundColor: '#D9E8EE',
          barThickness: barWidth,
        },
      ],
    },
    location: {
      labels: ['Pune', 'Mumbai', 'Bengluru'],
      datasets: [
        {
          label: 'location',
          data: ['Pune', 'Mumbai', 'Bengluru'],
          backgroundColor: '#D9E8EE',
          barThickness: barWidth,
        },
      ],
    },
  };

  useEffect(() => {
    coursePerformance(course_id)
    userCoursepScore(course_id)
    userCoursepAttempt(course_id)
    orgUserTestCard(course_id)
  }, [])

  useEffect(() => {
    coursePerformanceAnalytics(course_id, activeFilter);
    userCoursepScore(course_id, activeFilter);
    userCoursepAttempt(course_id, activeFilter);
  }, [activeFilter, course_id])


  const options2 = {
    responsive: true,
    maintainAspectRatio: false,
    categoryPercentage: 2.1, // Reduces bar width to create more space between groups
    barPercentage: 2.1, // Controls bar thickness within each group
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const dataPoint = tooltipItem.raw;
            const label = tooltipItem.label;
            return ` ${label.charAt(0).toUpperCase() + label.slice(1)}` + ' : ' + `${dataPoint} ` + 'Users';
          },
        }
      },
      legend: {
        display: true,
        position: 'bottom',
      },
      datalabels: {
        anchor: "middle",
        align: "middle",
        color: '#fff',
        font: {
          weight: '600'
        },
        formatter: (value) => {
          if (value === 0) {
            return ' ';
          }
          return value;
        }
      },
    }
  };

  const options = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    categoryPercentage: 0.6, // Reduces bar width to create more space between groups
    barPercentage: 0.6, // Controls bar thickness within each group
    plugins: {
      datalabels: {
        color: '#000',
        anchor: "end",
        align: "start",
        offset: (context) => {
          return context.dataset.data[context.dataIndex] === 0 ? -15 : 5;
        },
        font: {
          weight: '600'
        },
        formatter: (value) => {
          if (value === 0) {
            return '0';
          }
          return value;
        }
      },
      legend: {
        display: false,
        position: 'bottom',
        borderRadius: 5
      }
    },
    scales: {
      x: {
        display: true,
        grid: {
          display: true,
        },
      },
      y: {
        display: true,
        grid: {
          display: false,
        },
      }
    },
    onResize: (chart, size) => {
      // Force chart update on resize
      chart.update('resize');
    },
  };

  const handleFilterClick = (filter) => {
    setActiveFilter((prevFilter) => {
      if (prevFilter !== filter) {
        coursePerformance(course_id, filter);
        coursePerformanceAnalytics(course_id, filter)
      }
      return filter;
    });
  };
  // apiService.getanalytics(`course-performance?org_id=${org_id||''}&course_id=${course_id || ''}&completion_percent=100&filter=${filter || ''}`,token)
  const coursePerformance = (course_id, filter) => {
    setLoader(true)
    const token = apiService.getAuthToken()
    const org_id = localStorage.getItem("ORGID")
    apiService.getanalytics(`course-performance?org_id=${org_id || ''}&course_id=${course_id || ''}&user_course_status=pass&analytics_category=course_performance&filter=${filter || ''}`, token).then((response) => {
      console.log("response", response)
      if (response?.data) {
        setCoursePerformanceDatas(response?.data, filter)
        setCoursePerformances(response?.data)
        setLoader(false)
      }
    }).catch((err) => {
      console.log(err)
      setLoader(false)
    })
  }

  const coursePerformanceAnalytics = (course_id, filter) => {
    setLoader(true)
    const token = apiService.getAuthToken()
    const org_id = localStorage.getItem("ORGID")
    apiService.get(`get-performance-analytics?org_id=${org_id || ''}&course_id=${course_id || ''}&filter=${filter || ''}`, token).then((response) => {
      console.log("getPerformanceAnalytic response", response)
      if (response?.data) {
        setCoursePerformanceAnalyticsDatas(response?.data, filter)
        setCoursePerformancesAnalytics(response?.data)

        setLoader(false)
      }
    }).catch((err) => {
      console.log(err, "error")
      setLoader(false)
    })
  }

  const userCoursepScore = (course_id, filter) => {
    setLoader(true)
    const token = apiService.getAuthToken()
    const org_id = localStorage.getItem("ORGID")
    apiService.getanalytics(`user-course-score?org_id=${org_id || ''}&course_id=${course_id || ''}&user_course_status=pass&test_type=end_line&filter_type=${activeFilter || ''}`, token).then((response) => {
      console.log("response", response)
      if (response?.data) {
        setEndlineScoreDatas(response?.data)
        // setUCourseScore(response?.data)
        setLoader(false)
      }
    }).catch((err) => {
      setLoader(false)
      console.log(err)
    })
  }

  const userCoursepAttempt = (course_id, filter) => {
    const token = apiService.getAuthToken()
    const org_id = localStorage.getItem("ORGID")
    apiService.getanalytics(`course-attempt-performance?org_id=${org_id || ''}&course_id=${course_id || ''}&user_course_status=pass&test_type=end_line&filter_type=${activeFilter || ''}`, token).then((response) => {
      console.log("response", response)
      if (response?.data) {
        setEndlineAttemptDatas(response?.data)
        setUserCoursepAttempt(response?.data)
      }
    })
  }

  const orgUserTestCard = (course_id) => {
    const token = apiService.getAuthToken()
    const org_id = localStorage.getItem("ORGID")
    apiService.getanalytics(`user-test-report?org_id=${org_id || ''}&course_id=${course_id || ''}&user_course_status=pass`, token).then((response) => {
      console.log("response", response)
      if (response?.data) {
        setOrgUserTestCardData(response?.data)
      }
    })
  }

  const setCoursePerformanceDatas = (coursePerformanceProps, filter) => {
    coursePerformanceProps = Array.isArray(coursePerformanceProps) ? coursePerformanceProps : typeof coursePerformanceProps == 'object' ? [coursePerformanceProps] : []
    if (coursePerformanceProps && coursePerformanceProps.length > 0) {
      if (filter == 'all') {
        const labels = coursePerformanceProps && coursePerformanceProps?.map(course => course?.course_name)
        const baselineData = coursePerformanceProps?.map(course => {
          if (course?.tests_result) {
            const data = course?.tests_result.map(ele => {
              if (ele.test_type == "base_line") {
                return Math.round(ele?.average_marks);
              }
            }).filter(ele => ele != null || ele != undefined)
            return data[0]
          }
        }).filter(ele => ele != null || ele != undefined)
        const endLineData = coursePerformanceProps?.map(course => {
          if (course?.tests_result) {
            const data = course?.tests_result.map(ele => {
              if (ele.test_type == "end_line") {
                return Math.round(ele?.average_marks);
              }
            }).filter(ele => ele != null || ele != undefined)
            return data[0]
          }
        }).filter(ele => ele != null || ele != undefined)
        const basline = {
          label: 'BaseLine',
          data: baselineData,
          backgroundColor: ['#D9E8EE'],
          barThickness: barWidth,
        }
        const endLine = {
          label: 'EndLine',
          data: endLineData,
          backgroundColor: ['#146B90'],
          barThickness: barWidth,
        }
        const mData = {
          labels: labels,
          datasets: [basline, endLine]
        };
        setCoursePerformanceData(mData);
      }
      else if (filter == 'department') {
        const departmentDatas = coursePerformanceProps[0];
        const labels = Object.keys(departmentDatas).filter(key => key !== null && key !== "NULL" && key !== "" && key !== "null" && key !== "-");
        // remove the data
        const finalLabels = []

        let endLineData = [];
        let baseLineData = []
        for (const label of labels) {
          const departmentData = departmentDatas[label];
          if (departmentData && departmentData.length > 0) {
            let hasEndLine = false;
            let hasBaseLine = false;

            for (const data of departmentData) {
              if (data.test_type === "end_line") {
                endLineData.push(Math.round(data.average_marks));
                hasEndLine = true;
              } else if (data.test_type === "base_line") {
                baseLineData.push(Math.round(data.average_marks));
                hasBaseLine = true;
              }
            }

            if (!hasEndLine) {
              endLineData.push(0);
            }
            if (!hasBaseLine) {
              baseLineData.push(0);
            }
          } else {
            endLineData.push(0);
            baseLineData.push(0);
          }
        }
        const mData = {
          labels: labels,
          datasets: [
            {
              label: 'baseline',
              data: baseLineData,
              backgroundColor: '#D9E8EE',
              barThickness: barWidth,
            },
            {
              label: 'endline',
              data: endLineData,
              backgroundColor: '#146B90',
              barThickness: barWidth,
            },
          ]
        };
        setCoursePerformanceData(mData);
      } else if (filter == 'gender') {
        const genderDatas = coursePerformanceProps[0];
        const labels = Object.keys(genderDatas).filter(key => key != null && key != "NULL" && key != "" && key != "null")
        // const labels = Object.keys(genderDatas).filter(key => genderDatas[key].length > 0)
        let endLineData = [];
        let baseLineData = [];
        for (const label of labels) {
          const genderData = genderDatas[label];
          if (genderData && genderData.length > 0) {
            let hasEndLine = false;
            let hasBaseLine = false;

            for (const data of genderData) {
              if (data.test_type === "end_line") {
                endLineData.push(Math.round(data.average_marks));
                hasEndLine = true;
              } else if (data.test_type === "base_line") {
                baseLineData.push(Math.round(data.average_marks));
                hasBaseLine = true;
              }
            }

            if (!hasEndLine) {
              endLineData.push(0);
            }
            if (!hasBaseLine) {
              baseLineData.push(0);
            }
          } else {
            endLineData.push(0);
            baseLineData.push(0);
          }
        }
        const mData = {
          labels: labels,
          datasets: [
            {
              label: 'baseline',
              data: baseLineData,
              backgroundColor: '#D9E8EE',
              barThickness: barWidth,
            },
            {
              label: 'endline',
              data: endLineData,
              backgroundColor: '#146B90',
              barThickness: barWidth,
            },
          ]
        };
        setCoursePerformanceData(mData);
      } else if (filter == 'age_group') {
        const ageGroupDatas = coursePerformanceProps[0];
        const labels = Object.keys(ageGroupDatas).filter(key => key != null && key != "NULL" && key != "" && key != "null")
        // const labels = Object.keys(ageGroupDatas).filter(key => ageGroupDatas[key].length > 0)
        let endLineData = [];
        let baseLineData = [];
        for (const label of labels) {
          const ageGroupData = ageGroupDatas[label];
          if (ageGroupData && ageGroupData.length > 0) {
            let hasEndLine = false;
            let hasBaseLine = false;

            for (const data of ageGroupData) {
              if (data.test_type === "end_line") {
                endLineData.push(Math.round(data.average_marks));
                hasEndLine = true;
              } else if (data.test_type === "base_line") {
                baseLineData.push(Math.round(data.average_marks));
                hasBaseLine = true;
              }
            }

            if (!hasEndLine) {
              endLineData.push(0);
            }
            if (!hasBaseLine) {
              baseLineData.push(0);
            }
          } else {
            endLineData.push(0);
            baseLineData.push(0);
          }
        }

        const mData = {
          labels: labels,
          datasets: [
            {
              label: 'baseline',
              data: baseLineData,
              backgroundColor: '#D9E8EE',
              barThickness: barWidth,
            },
            {
              label: 'endline',
              data: endLineData,
              backgroundColor: '#146B90',
              barThickness: barWidth,
            },
          ]
        };
        setCoursePerformanceData(mData);
      } else if (filter == 'location') {
        const locationDatas = coursePerformanceProps[0];
        const labels = Object.keys(locationDatas).filter(key => key != null && key != "NULL" && key != "" && key != "null" && key !== "-")
        // const labels = Object.keys(genderDatas).filter(key => genderDatas[key].length > 0)
        let endLineData = [];
        let baseLineData = [];
        for (const label of labels) {
          const locationData = locationDatas[label];
          if (locationData && locationData.length > 0) {
            let hasEndLine = false;
            let hasBaseLine = false;

            for (const data of locationData) {
              if (data.test_type === "end_line") {
                endLineData.push(Math.round(data.average_marks));
                hasEndLine = true;
              } else if (data.test_type === "base_line") {
                baseLineData.push(Math.round(data.average_marks));
                hasBaseLine = true;
              }
            }

            if (!hasEndLine) {
              endLineData.push(0);
            }
            if (!hasBaseLine) {
              baseLineData.push(0);
            }
          } else {
            endLineData.push(0);
            baseLineData.push(0);
          }
        }
        const mData = {
          labels: labels,
          datasets: [
            {
              label: 'baseline',
              data: baseLineData,
              backgroundColor: '#D9E8EE',
              barThickness: barWidth,
            },
            {
              label: 'endline',
              data: endLineData,
              backgroundColor: '#146B90',
              barThickness: barWidth,
            },
          ]
        };
        setCoursePerformanceData(mData);
      } else if (filter == 'org_entity') {
        const locationDatas = coursePerformanceProps[0];
        const labels = Object.keys(locationDatas).filter(key => key != null && key != "NULL" && key != " " && key != "null" && key !== "-")
        // const labels = Object.keys(genderDatas).filter(key => genderDatas[key].length > 0)
        let endLineData = [];
        let baseLineData = [];
        for (const label of labels) {
          const locationData = locationDatas[label];
          if (locationData && locationData.length > 0) {
            let hasEndLine = false;
            let hasBaseLine = false;

            for (const data of locationData) {
              if (data.test_type === "end_line") {
                endLineData.push(Math.round(data.average_marks));
                hasEndLine = true;
              } else if (data.test_type === "base_line") {
                baseLineData.push(Math.round(data.average_marks));
                hasBaseLine = true;
              }
            }

            if (!hasEndLine) {
              endLineData.push(0);
            }
            if (!hasBaseLine) {
              baseLineData.push(0);
            }
          } else {
            endLineData.push(0);
            baseLineData.push(0);
          }
        }
        const mData = {
          labels: labels,
          datasets: [
            {
              label: 'baseline',
              data: baseLineData,
              backgroundColor: '#D9E8EE',
              barThickness: barWidth,
            },
            {
              label: 'endline',
              data: endLineData,
              backgroundColor: '#146B90',
              barThickness: barWidth,
            },
          ]
        };
        setCoursePerformanceData(mData);
      }
      else {
        const labels = coursePerformanceProps && coursePerformanceProps?.map(course => course?.course_name)
        const baselineData = coursePerformanceProps?.map(course => {
          if (course?.tests_result) {
            const data = course?.tests_result.map(ele => {
              if (ele.test_type == "base_line") {
                return Math.round(ele?.average_marks);
              }
            }).filter(ele => ele != null || ele != undefined)
            return data[0]
          }
        }).filter(ele => ele != null || ele != undefined)
        const endLineData = coursePerformanceProps?.map(course => {
          if (course?.tests_result) {
            const data = course?.tests_result.map(ele => {
              if (ele.test_type == "end_line") {
                return Math.round(ele?.average_marks);
              }
            }).filter(ele => ele != null || ele != undefined)
            return data[0]
          }
        }).filter(ele => ele != null || ele != undefined)
        const basline = {
          label: 'BaseLine',
          data: baselineData,
          backgroundColor: ['#D9E8EE'],
          barThickness: barWidth,
        }
        const endLine = {
          label: 'EndLine',
          data: endLineData,
          backgroundColor: ['#146B90'],
          barThickness: barWidth,
        }
        const mData = {
          labels: labels,
          datasets: [basline, endLine]
        };
        setCoursePerformanceData(mData)
      }
    } else {
      setCoursePerformanceData([])
    }
  }

  const setEndlineAttemptDatas = (attemptsProps, filter) => {
    attemptsProps = Array.isArray(attemptsProps) ? attemptsProps : []
    if (attemptsProps && attemptsProps.length > 0) {
      const labels = Object.keys(attemptsProps[0])
      const datasets = [
        {
          label: 'Attempt',
          data: labels.map(section => attemptsProps.reduce((acc, obj) => acc + obj[section].users, 0)),
          backgroundColor: ['#146B90', '#22A298', '#F4B532', '#F59390', '#22A298'],
          barThickness: barWidth,
        }
      ]
      const mData = {
        labels: labels,
        datasets: datasets
      };
      setCourseAttempData(mData)
    }
  }

  const setEndlineScoreDatas = (attemptsProps, filter) => {
    attemptsProps = Array.isArray(attemptsProps) ? attemptsProps : []
    if (attemptsProps && attemptsProps.length > 0) {
      const labels = Object.keys(attemptsProps[0])
      const datasets = [
        {
          label: 'Score',
          data: labels.map(section => attemptsProps.reduce((acc, obj) => acc + obj[section], 0)),
          backgroundColor: ['#146B90', '#22A298', '#F4B532', '#ED483D', '#22A298'],
          barThickness: barWidth,
        }
      ]
      const mData = {
        labels: labels,
        datasets: datasets
      };
      setCourseScoreData(mData)
    }
  }

  const colorCode = ["#146B90", "#F4B532", "#F59390", "#22A298"];


  const downloadDetailsReport = async (courseDetails, filter) => {
    setLoader(true);
    let user_details = localStorage.getItem('user_details')
    const org_id = localStorage.getItem("ORGID")
    const token = apiService.getAuthToken()
    await apiService.get(`get-org-admin-course-report?org_id=${org_id}&org_course_id=${org_course_id}&filter_type=${activeFilter || ''}`, token).then((data) => {
      if (data?.status == "success" || data?.success == true) {
        window.open(data?.data, "_blank")
      }
      setLoader(false);
    }).catch(error => {
      console.log(error)
      setLoader(false);
    })
  }

 // Filter options for course performance
  const filterOptions = [
    { value: 'all', label: 'All' },
    { value: 'entity', label: 'Entity' },
    { value: 'location', label: 'Location' },
    { value: 'designation', label: 'Designation' }
  ];

  // Calculate remaining data first
  const remainingInviteSent = 0;
  const remainingInviteAccepted = parseInt(coursePerformanceAnalyticsDatas?.invitationSent) - parseInt(coursePerformanceAnalyticsDatas?.invitationAccepted);
  const remainingInProgress = parseInt(coursePerformanceAnalyticsDatas?.invitationAccepted) - (parseInt(coursePerformanceAnalyticsDatas?.courseInProgress) + parseInt(coursePerformanceAnalyticsDatas?.courseCompleted));
  const remainingCompleted = parseInt(coursePerformanceAnalyticsDatas?.courseCompleted) === 0 ? parseInt(coursePerformanceAnalyticsDatas?.courseInProgress) : 0;

  const remainingData = [
    remainingInviteSent,
    remainingInviteAccepted < 0 ? 0 : remainingInviteAccepted,
    remainingInProgress,
    remainingCompleted,
  ];

  const colors = ['#045e7c', '#f5c16c', '#f2797b', '#3cb4a5'];

  const licenseStatusData = {
    labels: ['Invitation Sent', 'Invitation Accepted', 'In Progress', 'Course Completed'],
    datasets: [{
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const dataPoint = tooltipItem.raw;
            const label = tooltipItem.label;
            return ` ${label.charAt(0).toUpperCase() + label.slice(1)}` + ' : ' + `${dataPoint} ` + 'Users';
          },
        }
      },
      label: 'License Status',
      data: [
        coursePerformanceAnalyticsDatas?.invitationSent || 0,
        coursePerformanceAnalyticsDatas?.invitationAccepted || 0,
        coursePerformanceAnalyticsDatas?.courseInProgress || 0,
        coursePerformanceAnalyticsDatas?.courseCompleted || 0,
      ],
      stack: 'stack2',
      backgroundColor: ['#045e7c', '#f5c16c', '#f2797b', '#3cb4a5'],
      barThickness: 32,
      categoryPercentage: 0.15, // Adjust this value for spacing
      barPercentage: 0.15, // Adjust this value for spacing
    },
    {
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const dataPoint = tooltipItem.raw;
            const label = tooltipItem.label;
            if (label === 'In Progress') {
              return ` Not Started` + ' : ' + `${dataPoint} ` + 'Users';
            } else if (label === 'Invitation Sent') {
              return ` Licenses Remaining` + ' : ' + `${dataPoint} ` + 'Users';
            } else if (label === 'Invite Accepted') {
              return ` Not Accepted` + ' : ' + `${dataPoint < 0 ? 0 : dataPoint} ` + 'Users';
            } else if (label === 'Course Completed') {
              return ` Course Incomplete` + ' : ' + `${dataPoint} ` + 'Users';
            }
            return ` ${label.charAt(0).toUpperCase() + label.slice(1)}` + ' : ' + `${dataPoint} ` + 'Users';
          },
        }
      },
      backgroundColor: colors.map(color => createDiagonalPattern(color)),
      borderColor: ['#045e7c', '#f5c16c', '#f2797b', '#3cb4a5'],
      data: remainingData,
      barThickness: 30,
      stack: 'stack2',
      borderWidth: 0.1,
    }
    ],
  };

  // Dynamic performance status data from course performance analytics
  const orgUserTestCardDatas = {
    labels: ['Endline Passed', 'Endline Failed', 'Users Flagged'],
    datasets: [
      {
        label: 'Performance Status',
        data: [
          coursePerformanceAnalyticsDatas?.passed_users || 0,
          coursePerformanceAnalyticsDatas?.failed_users || 0,
          coursePerformanceAnalyticsDatas?.flagged_users || 0
        ],
        backgroundColor: ['#3cb4a5', '#ea5656', '#f28c8c'],
        barThickness: 32,
      },
    ],
  };

  function createDiagonalPattern(color) {
    // create a 10x10 px canvas for the pattern's base shape
    const shape = document.createElement('canvas');
    shape.width = 10;
    shape.height = 10;
    const c = shape.getContext('2d');

    // draw the diagonal lines
    c.strokeStyle = color;
    c.beginPath();
    c.moveTo(2, 0);
    c.lineTo(10, 8);
    c.stroke();
    c.beginPath();
    c.moveTo(0, 8);
    c.lineTo(2, 10);
    c.stroke();

    // create the pattern from the shape
    return c.createPattern(shape, 'repeat');
  }

  const options3 = {
    indexAxis: 'y',
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
       datalabels: {
        color: '#000',
        anchor: (context) => context.dataset.data[context.dataIndex] < 10 ? "middle" : "middle",
        align: "middle",
        offset: (context) => {
          return context.dataset.data[context.dataIndex] > 10 ? 10 : -7;
        },
        font: {
          weight: '600'
        },
        formatter: (value) => {
          if (value === 0) {
            return ' ';
          }
          return value;
        }
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: false,
        },
        ticks: {
          stepSize: 50,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <div className='page__main'>
      <style>
        {`
          .chart-scroll-container::-webkit-scrollbar {
            width: 8px;
          }
          .chart-scroll-container::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
          }
          .chart-scroll-container::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 4px;
          }
          .chart-scroll-container::-webkit-scrollbar-thumb:hover {
            background: #a8a8a8;
          }
        `}
      </style>
      <div className="dashboard jetadmin" style={{ minHeight: '100vh' }}>

       <nav aria-label="breadcrumb mb-3">
          <ol className="breadcrumb mb-1">
            <li className="breadcrumb-item"><span className='fw-bold font-26'>{course_name}</span></li>
            <li className="breadcrumb-item fw-bold font-26" aria-current="page">Stats</li>
          </ol>
        </nav>
        <p className='font-14 mb-3'>Access detailed performance insights across teams, locations, and demographics to track progress and impact.</p>

         <div className='bg-white rounded-4 shadow-sm px-2 py-3 mb-3'>
          <div className='w-50 d-flex justify-content-start'>
            <div className='mx-2 p-3 col-4 rounded-3 bg_green d-flex justify-content-between align-items-start'>
              <div className='col'>
                <h2 className='d-flex justify-content-between text-white fw-bold'>{coursePerformanceAnalyticsDatas?.passed_users}</h2>
                <h3 className='font-18 text-white mb-0 mt-3 fw-bold'>Course Passed</h3>
              </div>
              <div class="tooltip">i
                <span class="tooltiptext">Users who successfully passed the endline test, regardless of whether they have completed the entire course.</span>
              </div>
            </div>
            <div className='mx-2 p-3 col-4 rounded-3 bg_red d-flex justify-content-between align-items-start'>
              <div className='col'>
                <h2 className='d-flex justify-content-between text-white fw-bold'>{coursePerformanceAnalyticsDatas?.failed_users}</h2>
                <h3 className='font-18 text-white mb-0 mt-3 fw-bold'>Course Failed</h3>
              </div>
              <div class="tooltip">i
                <span class="tooltiptext">Users who did not achieve the passing score on the endline test.</span>
              </div>
            </div>
            <div className='mx-2 p-3 col-4 rounded-3 bg_pink d-flex justify-content-between align-items-start'>
              <div className='col'>
                <h2 className='d-flex justify-content-between text-white fw-bold'>{coursePerformanceAnalyticsDatas?.flagged_users}</h2>
                <h3 className='font-18 text-white mb-0 mt-3 fw-bold'>Course Flagged</h3>
              </div>
              <div class="tooltip">i
                <span class="tooltiptext">Users who required more than 3 attempts to pass the endline test, marked for review or additional support.</span>
              </div>
            </div>
          </div>
        </div>
   
        {loader ? <Loader /> : (
          <div className="w-100">
            <div className='d-flex justify-content-between align-items-center w-100'>
              <h3 className='fw-bold font-20 my-4'><span className='text-decoration-none text-black'>Course Performance</span></h3>
              <button className='btn btn-md btn-secondary px-3 d-flex justify-content-between align-items-center ' onClick={() => downloadDetailsReport()}><img src='/images/excel-report-icon.svg' alt="excel-report" className='me-2' width={22} height={22} />Download User Wise Report</button>
            </div>
            <hr />
            <div className='d-flex justify-content-between border-bottom pb-0 mb-4'>
              <div className='filters mb-4'>
                <button className='btn btn-link text-decoration-none me-2 pe-3 border-end border-2'
                  onClick={() => handleFilterClick('all')}
                  style={{ color: activeFilter === 'all' ? '#146B90' : '#000000' }}
                >
                  All
                </button>
                <button className='btn btn-link text-decoration-none me-2 border-end border-2 pe-3'
                  onClick={() => handleFilterClick('org_entity')}
                  style={{ color: activeFilter === 'org_entity' ? '#146B90' : '#000000' }}
                >
                  Entity
                </button>
                <button className='btn btn-link text-decoration-none me-2 border-end border-2 pe-3'
                  onClick={() => handleFilterClick('department')}
                  style={{ color: activeFilter === 'department' ? '#146B90' : '#000000' }}
                >
                  Department
                </button>
                {orgId && orgId != '7c13b617-55a1-4ea6-810a-7bf05aaf52af' ? <>
                  <button className='btn btn-link text-decoration-none border-end border-2 me-2'
                    onClick={() => handleFilterClick('age_group')}
                    style={{ color: activeFilter === 'age_group' ? '#146B90' : '#000000' }}
                  >
                    Age
                  </button>
                  <button className='btn btn-link text-decoration-none me-2 border-end border-2 pe-3'
                    onClick={() => handleFilterClick('gender')}
                    style={{ color: activeFilter === 'gender' ? '#146B90' : '#000000' }}
                  >
                    Gender
                  </button></> : ' '}
                <button className='btn btn-link text-decoration-none me-2 pe-3'
                  onClick={() => handleFilterClick('location')}
                  style={{ color: activeFilter === 'location' ? '#146B90' : '#000000' }}
                >
                  Location
                </button>
              </div>
            </div>

            <div className="d-flex gap-4 flex-wrap px-0">
              <div className='statistics shadow-sm bg-white p-3 mb-4' style={{ flex: 1, minWidth: '300px' }}>
                <h5 className='fw-bold font-20 my-2 pb-2'>License Status: {activeFilter.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}</h5>
                <Bar data={licenseStatusData} options={options3} plugins={[ChartDataLabels]} />
              </div>
              <div className='statistics shadow-sm bg-white p-3 mb-4' style={{ flex: 1, minWidth: '300px' }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className='fw-bold font-20 my-2 pb-2'>Performance Status: {activeFilter.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}</h5>
                  {course_id && (
                    <select
                      className="form-select form-select-sm"
                      style={{ width: 'auto' }}
                      value={activeFilter}
                      onChange={(e) => setActiveFilter(e.target.value)}
                    >
                      {filterOptions.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  )}
                </div>
                {loader ? (
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <Bar data={orgUserTestCardDatas} options={options3} plugins={[ChartDataLabels]} />
                )}
              </div>
            </div>

            <div className='statistics bg-white p-3 shadow-sm'>
                <h3 className='fw-bold font-20 my-2 pb-4'>Baseline VS Endline: {activeFilter.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}</h3>
                {coursePerformanceData?.labels?.length > 0 ?
                  <div 
                    style={{ 
                      height: '450px',
                      maxHeight: '450px',
                      overflowY: 'scroll', // Changed from 'auto' to 'scroll' to always show scrollbar
                      overflowX: 'hidden',
                      position: 'relative',
                      scrollbarWidth: 'thin', // For Firefox
                      scrollbarColor: '#c1c1c1 #f1f1f1' // For Firefox
                    }}
                    className="chart-scroll-container"
                  >
                    <div style={{ 
                      height: coursePerformanceData?.labels?.length > 5 ? `${coursePerformanceData?.labels?.length * 80}px` : '400px',
                      width: '100%',
                      minHeight: '400px',
                      padding: '20px 10px'
                    }}>
                      <Bar 
                        data={{
                          labels: coursePerformanceData?.labels || [],
                          datasets: coursePerformanceData?.datasets || [],
                        }} 
                        options={options} 
                        plugins={[ChartDataLabels]}
                      />
                    </div>
                  </div> : <p className='fw-regular font-16 my-2'>Data not found.</p>}
              </div>

            {coursePerformances && coursePerformances.length > 0 && activeFilter == '' || activeFilter == 'all' && coursePerformances?.map((course, index) => (
              <div className='statistics shadow-sm bg-white p-3 mt-4'>
                <div key={index}>
                  <h3 className='statistics text-capitalize p-3 fw-bold font-20 radius-0'>Shift In Understanding</h3>
                  <div className='statistics bg-white p-3 mt-4 d-flex flex-wrap'>
                    <div className="col-3 mb-2 text-center">
                      {course?.tests_result?.some(result => result.test_type === 'base_line') ? (
                        course.tests_result.map((testResult, i) => (
                          testResult.test_type === 'base_line' && (
                            <div key={i}>
                              <h2 className="fw-bold font-26">
                                {testResult?.average_marks !== "NA" && testResult?.average_marks != null
                                  ? Math.round(testResult.average_marks)
                                  : 'N/A'}
                              </h2>
                              <h3 className="fw-medium font-18 mt-2">Avg. Base Line</h3>
                            </div>
                          )
                        ))
                      ) : (
                        <>
                          <h2 className="fw-bold font-26">N/A</h2>
                          <h3 className="fw-medium font-18 mt-2">Avg. Base Line</h3>
                        </>
                      )}
                    </div>

                    <div className="col-3 mb-2 text-center">
                      {course?.tests_result?.some(result => result.test_type === 'end_line') ? (
                        course.tests_result.map((testResult, i) => (
                          testResult.test_type === 'end_line' && (
                            <div key={i}>
                              <h2 className="fw-bold font-26">
                                {testResult?.average_marks !== "NA" && testResult?.average_marks != null
                                  ? Math.round(testResult.average_marks)
                                  : 'N/A'}
                              </h2>
                              <h3 className="fw-medium font-18 mt-2">Avg. End Line</h3>
                            </div>
                          )
                        ))
                      ) : (
                        <>
                          <h2 className="fw-bold font-26">N/A</h2>
                          <h3 className="fw-medium font-18 mt-2">Avg. End Line</h3>
                        </>
                      )}
                    </div>
                    <div className="col-3 mb-2 text-center">
                      {course?.tests_result?.some(result => result.test_type === 'end_line') ? (
                        course.tests_result.map((testResult, i) => (
                          testResult.test_type === 'end_line' && (
                            <div key={i}>
                              <h2 className="fw-bold font-26">
                                {testResult?.average_attempts !== "NA" && testResult?.average_attempts != null
                                  ? Math.round(testResult.average_attempts)
                                  : 'N/A'}
                              </h2>
                              <h3 className="fw-medium font-18 mt-2">Avg. Attempts</h3>
                            </div>
                          )
                        ))
                      ) : (
                        <>
                          <h2 className="fw-bold font-26">N/A</h2>
                          <h3 className="fw-medium font-18 mt-2">Avg. Attempts</h3>
                        </>
                      )}
                    </div>

                    <div className="col-3 mb-2 text-center">
                      <h2 className="fw-bold font-26 text-green">{course?.change_percent != "NA" ? Math.round(course?.change_percent) + '%' : 'N/A'}</h2>
                      <h3 className="fw-medium font-18 mt-2">Change</h3>
                    </div>
                    {/* ))} */}
                  </div>
                </div>
              </div>
            ))}

          </div>)
        }
        {console.log("endline==>score", courseScoreData)}
        <div className="stats d-flex justify-content-between align-items-center my-4">
          {loader ? <Loader /> : courseScoreData && Object.keys(courseScoreData).length > 0 ? <div className="w-50 bg-white p-3 me-3 rounded-4 shadow-sm">

            <h3 className="fw-bold font-20 mb-4">Endline Score Breakup</h3>
            <hr />
            {console.log("endline==>score", courseScoreData)}
            {courseScoreData ? <Doughnut
              data={courseScoreData}
              options={options2}
              plugins={[ChartDataLabels]}
            /> : null}
          </div> : null}
          {loader ? <Loader /> : courseAttempData && Object.keys(courseAttempData).length > 0 ? <div className="w-50 bg-white p-3 ms-3 rounded-4 shadow-sm">

            <h3 className="fw-bold font-20 mb-4">Endline Attempts</h3>
            <hr />
            {console.log("endline==>attempt", courseAttempData)}
            {courseAttempData ? <Doughnut
              data={courseAttempData}
              options={options2}
              plugins={[ChartDataLabels]}
            /> : null}
          </div> : null}
        </div>

      </div>
    </div>
  )

}

export default Stats;